module.exports = __webpack_public_path__ + "static/img/pico43.b0f3439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico43.png
// module id = jyC0
// module chunks = 0